import { createSelector } from "reselect";

import {
  PortalSettings,
  TenantEnum,
  useSettingsQuery,
} from "../../store/coreApi";

export type PortalSettingsContextType = {
  isLoading: boolean;
  settings: Partial<
    PortalSettings & {
      isNational: boolean;
      isRegional: boolean;
    }
  >;
};

export const enrichPortalSettings = (settings: PortalSettings) => ({
  ...settings,
  isNational: settings.tenant === TenantEnum.National,
  isRegional: settings.tenant === TenantEnum.Regional,
});

const selectSettingsData = createSelector(
  (data: PortalSettings | undefined) => data,
  (data) => (data ? enrichPortalSettings(data) : {})
);

const usePortalSettings = () =>
  useSettingsQuery(undefined, {
    selectFromResult: ({ data, isLoading }): PortalSettingsContextType => ({
      settings: selectSettingsData(data),
      isLoading,
    }),
  });

export default usePortalSettings;
